/**
 *
 * App
 *
 * This component is the skeleton around the actual pages, and should only
 * contain code that should be seen on all pages. (e.g. navigation bar)
 */

import { Helmet } from 'react-helmet-async';
import { Switch, Route, BrowserRouter } from 'react-router-dom';

import { GlobalStyle } from 'styles/global-styles';

import { MainLayout } from 'app/pages/MainLayout';
import { NotFoundPage } from 'app/pages/NotFoundPage';
import { ConnectWallet } from 'app/pages/ConnectWallet';
import { useTranslation } from 'react-i18next';
import 'styles/tailwind.css';
import { useEffect, useState } from 'react';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import { pageLoading, polkaService, serviceData } from 'store/app';
import valueToText from 'app/components/context/ValueToText';
import { getType } from 'app/pages/LoanList/store';
import { getFromLocalStorage } from 'utils/services/LocalStorage';
import { addressState } from 'store/web3';
import Initial from 'app/Initial';
import {
  amountFromWei,
  amountToWeiWithPrecision,
} from 'utils/contract/common-function';
import { BigNumber } from 'bignumber.js';
import { one, suffixInterest, zero } from 'constants/number';

export function usePolkaServiceData() {
  const [data, setData] = useState();
  const service = useRecoilValue(polkaService);
  const [serviceDataFetch, setInitService] = useRecoilState(serviceData);
  const address = useRecoilValue(addressState);
  const setLoading = useSetRecoilState(pageLoading);

  console.log('serviceDataFetch', serviceDataFetch);

  const initData = async () => {
    try {
      if (!service || !service.api) {
        return;
      }

      const { api } = service;
      // setLoading(true);
      const entries = await api.query.cdpEngine.collateralParams.entries();
      const keys = await api.query.cdpEngine.collateralParams.keys();

      const type = getType(api, 'cdpEngine', 'collateralParams');
      const assetsId = valueToText(type, entries);
      const arrKeys = valueToText(type, keys);

      const globalInterest =
        await api.query.cdpEngine.globalInterestRatePerSec();
      const globalInterestType = getType(
        api,
        'cdpEngine',
        'globalInterestRatePerSec',
      );
      const value = valueToText(globalInterestType, globalInterest);

      const assets = await api.query.assetRegistry.assets.entries();
      const assetType = getType(api, 'assetRegistry', 'assets');
      const tokens = valueToText(assetType, assets);

      const validAssetsQuery = await api.query.cdpEngine.collateralAssetIds();
      const validAssetType = getType(api, 'cdpEngine', 'collateralAssetIds');
      const validAssets = valueToText(validAssetType, validAssetsQuery);

      const defaultExchangeRateQuery = await api.consts.cdpEngine
        .defaultDebitExchangeRate;
      const defaultExchangeRate = valueToText(
        'ExchangeRate',
        defaultExchangeRateQuery,
      );
      console.log('defaultExchangeRate', defaultExchangeRate);

      let allLoanIds = [];

      if (address) {
        const accountAssetPositions =
          await api.query.loans.accountAssetPositions(address);
        const accountAssetPositionsType = getType(
          api,
          'loans',
          'accountAssetPositions',
        );
        allLoanIds = Object.values(
          valueToText(accountAssetPositionsType, accountAssetPositions),
        );
      }

      const assetArray = assetsId.reduce(
        (acc, curr) => [...acc, { tokenId: curr[0][0], ...curr[1] }],
        [],
      );
      const allTokens = tokens.reduce(
        (acc, curr) => [...acc, { tokenId: curr[0][0], ...curr[1] }],
        [],
      );
      const assetsKeys = arrKeys.reduce((acc, cur) => [...acc, cur[0]], []);
      return {
        assetArray,
        assetsKeys,
        defaultExchangeRate: defaultExchangeRate,
        allTokens: allTokens.filter(token =>
          Object.values(validAssets).includes(token.tokenId),
        ),
        allLoanIds,
        globalInterest: value
          ? amountFromWei(new BigNumber(value), 18).multipliedBy(suffixInterest)
          : zero,
      };
    } catch (err) {
      console.log(err.message);
    } finally {
      // setLoading(false);
    }
  };

  useEffect(() => {
    initData().then(setInitService);
  }, [service]);
}

export function App() {
  const { i18n } = useTranslation();
  const initData = useRecoilValue(serviceData);
  const setAddress = useSetRecoilState(addressState);
  const polka = useRecoilValue(polkaService);

  console.log('initData', initData);

  usePolkaServiceData();

  useEffect(() => {
    const account = getFromLocalStorage('account');

    if (account) {
      const parseAccount = JSON.parse(account);
      setAddress(parseAccount.address);
    }
  }, []);

  console.log('polka', { polka, initData });

  if (!polka || !polka.api || !initData) {
    console.log('1111');
    return <Initial />;
  }

  return (
    <BrowserRouter>
      <Helmet
        titleTemplate="%s - Fizen"
        defaultTitle="Fizen"
        htmlAttributes={{ lang: i18n.language }}
      >
        <meta
          name="description"
          content="Fizen - The decentralized platform for zUSD - a cross-chain, multi-collateral stablecoin on Polkafoundry network"
        />
      </Helmet>

      <Switch>
        <Route exact path="/connect" component={ConnectWallet} />
        <Route path="/" component={MainLayout} />
        <Route component={NotFoundPage} />
      </Switch>
      <GlobalStyle />
    </BrowserRouter>
  );
}
